import { ApiHelper } from './helper/ApiHelper';
import { _ } from 'core-js';
import { AESService } from "./AES.js";
let aesService = new AESService()
const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;
// const user = "legend";
// const partner = "PI2001020110000"
// const partner = "PI2001030135000"
// const partner = "PI200103013500"
// const partner = "PI2001030004400"
// const partner = "PI2001020101000"
// const answer = "894296675"
// const answer = "252665659"
// const answer="894296675"
const code = 2
const partnerId = 893
const companyCode = 1
const categoryCode = 3



export class SummaryServices {
    constructor() { }
    getPartnerForensic(pid, c) {
        const uri = `/api/forensics/intr/forensicDetails/partnerId/${pid}/categoryCode/${c}`
        return apiHelper.get(uri)
    }
    getCategoriesList(cc) {
        const uri = `/api/forensics/intr/categoryList`
        return apiHelper.get(uri)
    }
    getLocationsList(cc) {
        const uri = `/api/forensics/intr/cityList`
        return apiHelper.get(uri)
    }
    getForensicList(pno, psize, sortby, sortOrder, searchby, searchterm, pan, payload) {
        searchby = searchby ? searchby : ''
        searchterm = searchterm ? searchterm : ''
        const uri = `/api/forensics/intr/allDetails?pan=${pan}&searchTerm=${searchterm}&searchBy=${searchby}&pageNo=${pno}&pageSize=${psize}&sortBy=${sortby}&sortOrder=${sortOrder}`
        return apiHelper.post(uri, payload)
    }
    getClassificationMaster(data) {
        const uri = `/api/partner-mgmt/partnerclassifications`
        return apiHelper.get(uri)
    }
    getPartnerSuggestion(input) {
        const uri = `/api/partner-mgmt/partner-mgmt/partner/suggestionAll/`
        return apiHelper.post(uri, input)
    }
    getPartnerStatusDetails(partnerId, companyCode) {
        const uri = `/api/common-view/getStatusUpdateDetails`
        var data = {
            partnerId: partnerId,
            companyCode: companyCode
        }
        return apiHelper.post(uri,data)
    }
    updateCompanyName(pid, companyName, companyCode) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/companyName/${pid}/${companyName}/${userid}/${companyCode}`
        var data = {}
        return apiHelper.post(uri, data)
    }
    updateCountry(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/updateCountry`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }
    updateCountryWF(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common/countryUpdate`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }

    updateStatus(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/adminAction/updateStatus`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }
    updateStatutory(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/adminAction/admin/submitVatDocument`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }
    updatePanNumberAdmin(data) {
        let userid = sessionStorage.getItem('useridadmin')
        data["userId"] = userid
        const uri = `/api/common-view/admin/idCardValueEdit`
        return apiHelper.post(uri, data)
    }
    mergeAccountsAdmin(data) {
        let userid = sessionStorage.getItem('useridadmin')
        data["userId"] = userid
        const uri = `/api/common-view/admin/mergeAccounts`
        return apiHelper.post(uri, data)
    }
    updateFavour(pid, favour, companyCode, categoryCode) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/paymentInfavourOf/${pid}/companyCode/${companyCode}/categoryCode/${categoryCode}/${favour}/${userid}`
        return apiHelper.post(uri, {})
    }
    updateContact(data, pid) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/contactDetail/partnerId/${pid}`
        data.userId = userid
        return apiHelper.put(uri, data)
    }
    resendActivationMail(pid) {
        const uri = `/api/common-view/admin/resend/activationMail/${pid}`
        return apiHelper.put(uri, {})
    }
    resetDetaultPassword(pid) {
        const uri = `/api/adminAction/defaultPassword/partnerId/${pid}`
        return apiHelper.get(uri, {})
    }
    deleteDuplicate(piNo, categoryCode) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/delete/duplicatePartner/${piNo}/categoryCode/${categoryCode}/${userid}`
        return apiHelper.post(uri, {})
    }
    syncProfile(pid) { //todo
        const uri = `/api/common-view/admin/partnerSync/partnerNumber/${pid}`
        return apiHelper.get(uri, {})
    }
    activateGST(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/activateGst`
        data.userId = userid
        return apiHelper.put(uri, data)
    }
    insertToPsno(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/extendDocument`
        data.userId = userid
        return apiHelper.post(uri, data)
    }
    getNameByPSNo(psno) {
        const uri = `/api/common-view/findName/${psno}`
        return apiHelper.get(uri)
    }
    getDocQL(docnumber) {
        const uri = `/api/adminAction/quickLinkDeatils/documentNumber/${docnumber}`
        return apiHelper.get(uri)
    }
    updateGracePeriod(days, pid) {
        const uri = `/api/adminAction/updateGracePeriod/${pid}/days/${days}`
        return apiHelper.get(uri)
    }
    insertListNewBank(data) {
        const uri = `/api/adminAction/saveBankMaster`
        return apiHelper.post(uri, data)
    }
    sendbackPOBfromAdmin(pob, to, eid) {
        const uri = `/api/adminAction/OnboardingDocumentSendBack/${pob}/${to}/${eid}`
        return apiHelper.get(uri)
    }
    updateRegOfcAddr(data, pid) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/admin/address`
        data.updatedBy = userid
        data.insertedBy = userid
        return apiHelper.post(uri, data)
    }
    getContent(moduleName, answer, userid, auditNumber, isAdmin) {
        let uri = `/api/partner-summaries/${moduleName}/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}`
        if (isAdmin) {
            uri = `/api/partner-summaries/${moduleName}/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}/isAdmin/true`
        }
        return apiHelper.get(uri)
    }
    getBoardingQuestions(moduleCode, answer, userid, auditNumber, isInternational) {
        const uri = `/api/partner-summaries/onboard-questions/module-code/${moduleCode}/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}/isInternational/${isInternational}`
        return apiHelper.get(uri);
    }
    reviewForModule(data) {
        const uri = `/api/workflow-status`
        return apiHelper.post(uri, data)
    }
    setNotApplicableForFinanceApprover(doc) {
        const uri = `/api/financeNonApplicability/${doc}`
        return apiHelper.get(uri)
    }
    submitOverAllStatus(data) {
        const uri = `/api/workflow-status-final`
        return apiHelper.post(uri, data)
    }

    uploadAttachments(data) {
        const uri = "/api/fileUpload"
        return apiHelper.postFile(uri, data);
    }
    downLoadDocument(documentId) {
        const uri = `/api/fileDownload/${documentId}`;
        return apiHelper.downloadFile(uri);
    }
    fetchAllReviews(answer, userid, auditNumber) {
        answer = aesService.EncodeUsingAES(answer);
        const uri = `/api/workflow-status/feedback/business-type/request-number/userid/${userid}/audit-number/${auditNumber}`
        var data = { "documentNumber": answer }
        return apiHelper.post(uri, data)
    }
    sendApproval(data, loginName) {
        // const uri = `/api/document-workflows/${loginName}-evaluation`;        
        const uri = `/api/partnerportal/workflow/document-workflows/approve`;
        return apiHelper.post(uri, data)
    }
    sendBack(data, loginName) {
        // const uri = `/api/document-workflows/${loginName}-evaluation`;        
        const uri = `/api/partnerportal/workflow/document-workflows/sendback`;
        return apiHelper.post(uri, data)
    }
    sendReject(data, loginName) {
        // const uri = `/api/document-workflows/${loginName}-evaluation`;        
        const uri = `/api/partnerportal/workflow/document-workflows/reject`;
        return apiHelper.post(uri, data)
    }
    getOverallReviews(answer, userID, auditNumber) {
        answer = aesService.EncodeUsingAES(answer);
        const uri = `/api/workflow-status-final/overall-feedback/request-number/userid/${userID}/audit-number/${auditNumber}`
        var data = { "documentNumber": answer }
        return apiHelper.post(uri, data)
    }

    financialOverAllRevenew(requestNo, userid) {
        requestNo = aesService.EncodeUsingAES(requestNo);
        const uri = `/api/financial-revenue/request-number/userid/${userid}`;
        var data = { "documentNumber": requestNo }
        return apiHelper.post(uri, data)
    }

    overAllSubmitStatus(answer, userid, auditNumber) {
        const uri = `/api/workflow-status/feedback/filled-status/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}`
        return apiHelper.get(uri);
    }
    overAllSubmitStatusReadOnly(answer, userid, auditNumber) {
        const uri = `/api/workflow-status/feedback/filled-status/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}/read-only`
        return apiHelper.get(uri);
    }
    checkOverAllStatus(answer, userid, auditNumber) {
        const uri = `/api/workflow-status/progress/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}`
        return apiHelper.get(uri);
    }
    checkOverAllStatusReadOnly(answer, userid, auditNumber) {
        const uri = `/api/workflow-status/progress/request-number/${answer}/userid/${userid}/audit-number/${auditNumber}/read-only`
        return apiHelper.get(uri);
    }
    getQandADetails(moduleCode, requestNumber, userid, auditNumber, isInternational) {
        requestNumber = aesService.EncodeUsingAES(requestNumber);
        const uri = `/api/onboard-questions/work-flow/module-code/${moduleCode}/request-number/userid/${userid}/audit-number/${auditNumber}/isInternational/${isInternational}`
        var data = { "documentNumber": requestNumber }
        return apiHelper.post(uri, data)
    }
    getQandADetailsConsolidated(requestNumber, userid, auditNumber, isInternational) {
        requestNumber = aesService.EncodeUsingAES(requestNumber);
        const uri = `/api/onboard-questions/work-flow/summaryAnswered/request-number/userid/${userid}/audit-number/${auditNumber}/isInternational/${isInternational}`
        var data = { "documentNumber": requestNumber }
        return apiHelper.post(uri, data)
    }

    getUserSegmentByFrCode(docnumber, frcode) {
        docnumber = aesService.EncodeUsingAES(docnumber);
        const uri = `/api/partnerportal/workflow/showTag/documentNumber/frCode/${frcode}`;
        var data = { "documentNumber": docnumber }
        return apiHelper.post(uri, data)
    }

    userLogout(data) {
        //data.loginAuditNumber = ''
        const uri = `/api/useraudit/logout`
        return apiHelper.post(uri, data)
    }
    getExtendSession(audit, user) {
        const uri = `/api/eip/extend/eip-user/session?audit-number=${audit}&user-id=${user}`
        return apiHelper.post(uri);
    }

    // SEGREGATOR

    getbuyerList() {
        const uri = '/api/document-workflows/segregator/evaluation'
        return apiHelper.get(uri);
    }

    allocateBuyer(data) {
        // const uri = `/api/document-workflows/segregator-evaluation`;   
        const uri = `/api/partnerportal/workflow/document-workflows/approve`;
        return apiHelper.post(uri, data)
    }

    intermediatePage(data) {
        const uri = '/api/eip/signin'
        return apiHelper.summaryLogin(uri, data);
    }

    getPartnerHeader(partnerId, partnerNumber, answerNumber, companyCode) {

        var passedCompanyCode;
        if (!companyCode) {
            passedCompanyCode = 0
        } else {
            passedCompanyCode = companyCode
        }
        const uri = `/api/common-view/headerDetails?partnerId=${partnerId}&partnerNumber=${partnerNumber}&requestNumber=${answerNumber}&companyCode=${passedCompanyCode}`;
        return apiHelper.get(uri);
    }

    getPartnerMaster(partnerId, companyCode, categoryCode) {
        const uri = `/api/common-view/footerDetails/partnerId/${partnerId}/companyCode/${companyCode}/categoryCode/${categoryCode}`;
        return apiHelper.get(uri);
    }

    getModules(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/partner-onboard/modules`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }
    getModulesCompletion(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/onboard-questions`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }

    getContentAdmin(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/common-view/admin/onboardDetails`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }
    saveFleetCard(data) {
        var userid = sessionStorage.getItem('useridadmin')
        const uri = `/api/adminAction/updateFleetCardTag`
        data["userId"] = userid
        return apiHelper.post(uri, data)
    }

    getWorkbenchList(companyCode, eipUID, currentpage, currentperpage, searchTerm) {
        const uri = `/api/workflow/workbench/documentList?companyCode=${companyCode}&eipUserId=${eipUID}&pageNo=${currentpage}&pageSize=${currentperpage}&searchTerm=${searchTerm}`
        return apiHelper.get(uri);
    }
    getWorkbenchListActionBy(companyCode, eipUID, currentpage, currentperpage, searchTerm) {
        const uri = `/api/workflow/workbench/actionBy?companyCode=${companyCode}&eipUserId=${eipUID}&pageNo=${currentpage}&pageSize=${currentperpage}&searchTerm=${searchTerm}`
        return apiHelper.get(uri);
    }

    getWorkbenchListCreatedBy(companyCode, eipUID, currentpage, currentperpage, searchTerm) {
        const uri = `/api/workflow/workbench/createdBy?companyCode=${companyCode}&eipUserId=${eipUID}&pageNo=${currentpage}&pageSize=${currentperpage}&searchTerm=${searchTerm}`
        return apiHelper.get(uri);
    }
    getGrievanceList(status) {
        const uri = `/api/claim/workflow/allGreievance/0`
        return apiHelper.get(uri);
    }
    downloadGrievanceList(data) {
        const uri = `/api/claim/workflow/downloadGrievances`
        return apiHelper.downloadGrFile(uri, data, 'grievance');
    }
    getGrievanceMetricsIcWiseStatus(ic, companyCode) {
        const uri = `/api/claimrequest/reportmetricsicwisestatus?iccode=${ic}&companyCode=${companyCode}`
        return apiHelper.get(uri)
    }
    getGrievanceMetricsOthers(ic, companyCode) {
        const uri = `/api/claimrequest/otherstaticmetrics?iccode=${ic}&companyCode=${companyCode}`
        return apiHelper.get(uri)
    }
    getGrievanceMetricsIcWiseReasons(ic, companyCode) {
        const uri = `/api/claimrequest/reportmetricsicwisereasons?iccode=${ic}&companyCode=${companyCode}`
        return apiHelper.get(uri)
    }

    getGrievanceMonthWise(ic, companyCode) {
        const uri = `/api/claimrequest/monthwisecount?iccode=${ic}&companyCode=${companyCode}`
        return apiHelper.get(uri)
    }
    getGrievanceMetricsIcsandStatus(companyCode) {
        const uri = `/api/claimrequest/reportmetricsbyicsandstatus?companyCode=${companyCode}`
        return apiHelper.get(uri)
    }
    getSegregatorList(requestNo, auditNumber) {
        requestNo = aesService.EncodeUsingAES(requestNo);
        const uri = `/api/onboard-answer-head/completed-list/request-number/audit-number/${auditNumber}`;
        var data = { "documentNumber": requestNo }
        return apiHelper.post(uri, data)
    }
    getSegregatorJob(companyCode, doptCode, userId) {
        const uri = `/api/partnerportal/workflow/buyer/job-list?dopt-code=${doptCode}&userId=${userId}`;
        var data = { "companyCode": companyCode }
        return apiHelper.post(uri, data);
    }
    getSegregatorBuyer(requestNo, jobCode, eipUserId) {
        const uri = `/api/partnerportal/workflow/document-workflows/request-number/${requestNo}/technicalCategorizer/jobCode/${jobCode}/${eipUserId}`;
        return apiHelper.get(uri);
    }

    getTrackingData(requestNo) {
        const uri = `/api/document-workflow-messages/request-number/${requestNo}`;
        return apiHelper.get(uri);
    }

    getQuicklinkTrackingData(requestNo) {
        const uri = `/api/quicklink-document-workflow-messages/request-number/${requestNo}`;
        return apiHelper.get(uri);
    }
    getContigentRadioInputValue(requestNo) {
        requestNo = aesService.EncodeUsingAES(requestNo);
        const uri = `/api/partner-classfications`
        var data = { "documentNumber": requestNo }
        return apiHelper.post(uri, data)
    }
    getContigentJobValue(requestNo, userid) {
        const uri = `/api/get-otjobs?answer-number=${requestNo}&user-id=${userid}`
        return apiHelper.get(uri);
    }
    getAutoCompleteData(searchCode, searchText) {
        const uri = `/api/partner-details/search?search=${searchCode}&search-term=${searchText}`;
        return apiHelper.get(uri);
    }
    getIsAllowEdit(eipUserId) {
        const uri = `/api/partner-details/alloweditvendormaster?eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getIsAllowAddBank(eipUserId) {
        const uri = `/api/partner-details/allowadminaddbank?eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getIsTechAdmin(companyCode, eipUserId) {
        const uri = `/api/partner-details/userAccessPage?companyCode=${companyCode}&eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getMenuPageCodeAccess(companyCode, eipUserId) {
        const uri = `/api/partner-details/userAccessPage?companyCode=${companyCode}&eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getIsAllowViewGrievanceDashboard(eipUserId) {
        const uri = `/api/partner-details/allowviewgrievancedashboard?eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getAdminApplicable(companyCode, eipUserId) {
        const uri = `/api/isCustomerAdmin?encCompanyCode=${companyCode}&eipUserId=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getReportsAdminApplicable(companyCode, eipUserId) {
        const uri = `/api/isReportsAdmin?encCompanyCode=${companyCode}&eipUserId=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getIsAllowViewCustomerDashboard(eipUserId) {
        const uri = `/api/partner-details/allowviewcustomerdashboard?eipuserid=${eipUserId}`;
        return apiHelper.get(uri);
    }
    getWorkFlowHistory(docnumber) {
        docnumber = aesService.EncodeUsingAES(docnumber);
        const uri = `/api/workflow-history/documentnumber`;
        let data = { "documentNumber": docnumber };
        return apiHelper.post(uri, data);
    }
    getWorkFlowHistorynew(docnumber) {
        docnumber = aesService.EncodeUsingAES(docnumber);
        const uri = `/api/workflow-history/documentnumber/new`;
        let data = { "documentNumber": docnumber };
        return apiHelper.post(uri, data);
    }
    getWorkFlowHistoryBetter(docnumber) {
        docnumber = aesService.EncodeUsingAES(docnumber);
        const uri = `/api/claim-trace/request-number`;
        let data = { "documentNumber": docnumber };
        return apiHelper.post(uri, data);
    }

    getDocumentList(pref, documentFor) {
        const uri = `/api/onboard-answer-head-list/pref/${pref}/documentfor/${documentFor}`
        return apiHelper.get(uri);
    }


    // GST APPROVAL
    getGstDetails(requestNo) {
        const uri = `/api/gst/summary/document-number/${requestNo}`;
        return apiHelper.get(uri);
    }

    summaryAction(data, workflowName, currentuser) {
        const uri = `/api/${workflowName}/workflow/${currentuser}`;
        return apiHelper.post(uri, data);
    }
    resolvePCR(data) {
        const uri = `/api/claimRequest/resolve`;
        return apiHelper.post(uri, data);
    }
    overallApprove(data, code, isPCR, isCOB, isKyc) {
        var uri = '';
        if (code == '1' && isPCR != true) {
            uri = `/api/partnerportal/modification/approve`;
        }
        if (code == '1' && isPCR == true) {
            uri = `/api/claim/workflow/grievance/employee/forward`;
        }
        if (code == '2' && isPCR != true) {
            uri = `/api/partnerportal/modification/sendback`;
        }
        if (code == '2' && isPCR == true) {
            uri = `/api/claim/workflow/sendback`;
        }
        if (code == '3') {
            uri = `/api/partnerportal/modification/reject`;
        }

        if (code == '1' && isCOB) {
            uri = `/api/customer-workflow/approve`;
        }
        if (code == '2' && isCOB) {
            uri = `/api/customer-workflow/sendback`;
        }
        if (code == '1' && isKyc) {
            uri = `/api/rekyc/workflow/approve`;
        }
        if (code == '2' && isKyc) {
            uri = `/api/rekyc/workflow/sendback`;
        }
        return apiHelper.post(uri, data);
    }
    trackingStatusDetails(requestNo) {
        const uri = `/api/document-workflow-messages/request-number/${requestNo}`
        return apiHelper.get(uri);
    }
    fetchClaimDetails(auditNumber, documentNumber) {

        documentNumber = aesService.EncodeUsingAES(documentNumber);
        const uri = `/api/ClaimRequest/workflow?auditNumber=${auditNumber}`
        let data = { "documentNumber": documentNumber };
        return apiHelper.post(uri, data);
    }
    fetchAddressApprovedDetails(auditNumber, documentNumber) {
        const uri = `/api/addressWorkflow/getApprovedDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchAddressQLDetails(auditNumber, documentNumber) {
        const uri = `/api/addressWorkflow/getDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchCountryApprovedDetails(auditNumber, documentNumber) {
        const uri = `/api/addressWorkflow/getApprovedDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchCountryQLDetails(auditNumber, documentNumber) {
        const uri = `/api/common/countryQlDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchStatApprovedDetails(auditNumber, documentNumber) {
        const uri = `/api/statutoryQl/getApprovedDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchStatQLDetails(auditNumber, documentNumber) {
        const uri = `/api/statutoryQl/getDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchStatusApprovedDetails(auditNumber, documentNumber) {
        const uri = `/api/common-view/getApprovedStatusDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    fetchStatusQLDetails(auditNumber, documentNumber) {
        const uri = `/api/common-view/getStatusQlDocumentDetails`
        let data = { "requestNumber": documentNumber, "auditNumber": auditNumber };
        return apiHelper.post(uri, data);
    }

    // QUICKLINK APPROVAL
    getQuicklinkDetails(requestNo) {

        requestNo = aesService.EncodeUsingAES(requestNo);
        const uri = `/api/partner/quick-link/summary/document-number`;
        let data = { "documentNumber": requestNo };
        return apiHelper.post(uri, data);
    }

    getCustomerDetailsDesc(data) {
        const uri = `/api/customers/workflow/masterData`
        return apiHelper.post(uri, data);
    }

    //FEEDBACK STATUS

    trackingDetailsOfFeedback(document) {
        const uri = `/api/remarks?document-number=${document}`;
        return apiHelper.get(uri);
    }

    //TESTIMONIAL APPROVAL

    getTestimonialsDetails(requestNo) {
        const uri = `/api/testimonials/workflow?document-number=${requestNo}`;
        return apiHelper.get(uri);
    }
    getForwardToList(pcrNumber) {
        pcrNumber = aesService.EncodeUsingAES(pcrNumber);

        const uri = `/api/claim/workflow/grievance/forwardToList/documentNumber`;
        let data = { "documentNumber": pcrNumber };
        return apiHelper.post(uri, data);
    }

    testimonialsApproval(data) {
        const uri = `/api/testimonials/document-workflows/buyer-evaluation`;
        return apiHelper.post(uri, data);
    }
    getApprovedBuyerTestimonials() {
        const uri = `/api/testimonials/approvedList/buyer`;
        return apiHelper.get(uri);
    }

    // BUSINESS CATEGORY WORKFLOW
    getBusinessCategories(requestNo) {
        const uri = `/api/partner/business-categories/document-number/${requestNo}`;
        return apiHelper.get(uri);
    }

    getPartnerApprovedBusinessCategories(requestNo) {
        const uri = `/api/partner/categories-approved?documentNumber=` + requestNo;
        return apiHelper.get(uri);
    }

    getPartnerRejectedBusinessCategories(requestNo) {
        const uri = `/api/partner/categories-rejected?documentNumber=` + requestNo;
        return apiHelper.get(uri);
    }

    buyerActionBusinessCategories(data) {
        const uri = `/api/business-category/workflow/buyer-evaluation`;
        return apiHelper.post(uri, data);
    }
    getEmpanelmentData(piNumber, categoryCode) {
        const uri = `/api/common-view/admin/getEmpanelmentDetails/${piNumber}/${categoryCode}`;
        return apiHelper.get(uri);
    }
    getEmpList(data) {
        const uri = `/api/claim/workflow/grievance/getEmployeeList`;
        return apiHelper.post(uri, data);
    }
    getKycDetails(documentNumber) {
        const uri = `/api/rekyc/workflow/documentDetails/${documentNumber}`
        return apiHelper.get(uri);
    }
}